export const COMMENT_WORKFLOW_STATES = {
  NEW: 'new',
  EDITED: 'edited',
  POSTED: 'posted',
  DELETED: 'deleted' // this state is present only on client
};